import {
  PACIENTE_SUCCESS,
  PACIENTE_LOADING,
  PACIENTE_ERROR,
  PACIENTE_EDITAR,
  PACIENTE_LOGOUT,
  RESET_PACIENTE,
  EDITANDO_PACIENTE,
  GETDATOSPACIENTE_SUCCESS,
  FINALIZAEDICION_PACIENTE,
  PACIENTE_BIOSEGURIDAD,
  PACIENTE_BIOSEGURIDAD_ERROR,
  PACIENTE_CAMBIOCLAVE,
  PACIENTE_EDITACLAVE,
  DROPDOWN_SELECT_USER_EDITAR_P,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

// Debe traer el idPacFamiliar
export const wsPostEditarPaciente = (paciente, idPacFamiliar) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post(
        `/paciente/editarPaciente/${!idPacFamiliar ? "" : idPacFamiliar}`,
        paciente
      )
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "editePaciente",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          status: err.response.status,
          detalle: err.response.data,
          origen: "editePaciente",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

//AGREGADOS.
export const editaPerfil = (handleHabilitaFormulario) => (dispatch) => {
  dispatch({
    type: EDITANDO_PACIENTE,
    payload: handleHabilitaFormulario,
  });
};

export const finalizaEdicion = () => (dispatch) => {
  dispatch({
    type: FINALIZAEDICION_PACIENTE,
  });
};
export const editarPaciente = (usuario) => (dispatch) => {
  dispatch({
    type: PACIENTE_EDITAR,
    payload: usuario,
  });
};

// Debe traer el idPacFamiliar
export const wsGetDatosPaciente = (idPacFamiliar) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/paciente/GetDatosPaciente/${!idPacFamiliar ? "" : idPacFamiliar}`)
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "actualizoDatos",
        };
        dispatch({
          type: GETDATOSPACIENTE_SUCCESS,
          error: null,
          loading: false,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "actualizoDatos",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const editandoClave = (body) => (dispatch) => {
  dispatch({
    type: PACIENTE_EDITACLAVE,
    payload: body,
  });
};

// Debe traer el id del paciente
export const wsPostActualizarClave =
  (clave, nueva_clave, paciente, token, nextStep) => (dispatch) => {
    dispatch({
      type: PACIENTE_LOADING,
    });
    axiosInstance().then((respuesta) => {
      respuesta
        .post(`/paciente/cambiar_clave`, {
          clave: clave,
          nueva_clave: nueva_clave,
          paciente: paciente,
          token: token,
        })
        .then((res) => {
          let respuesta = {
            ...res.data,
            origen: "cambioClave",
          };
          dispatch({
            type: PACIENTE_CAMBIOCLAVE,
            payload: respuesta,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          let error = {
            origen: "cambioClave",
            texto: err.response.data !== undefined ? err.response.data : "",
          };
          dispatch({
            type: PACIENTE_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error.texto);
        });
    });
  };

export const wsPutAceptaWsp = (valor, idPacFamiliar) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .put(
        `/paciente/aceptaAlertaWapp/${valor}/${
          !idPacFamiliar ? "" : idPacFamiliar
        }`
      )
      .then((res) => {
        let data = {
          pacienteActualizado: res.data,
          origen: "aceptaWsp",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "aceptaWsp",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

// Dejo 2 funciones /registro que se utilizan por fuera de signIn pero que tienen que ver con el Paciente.

export const wsGetCambioClave = (dni, nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get("/registro/cambio_clave/" + dni)
      .then((res) => {
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: res.data,
        });
        nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          status: err.response.status,
          data: err.response.data,
        };
        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
        nextStep(false, error);
      });
  });
};

export const wsPostConfirmaCodigo = (codigo, nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/registro/cambio_clave/codigo", {
        codigo: codigo,
      })
      .then((res) => {
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: res.data,
        });
        if (res.data !== null) {
          nextStep(true, res.data, codigo);
        }
      })
      .catch((err) => {
        let error = {
          status: err.response.status,
          data: err.response.data,
        };
        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
        nextStep(false, error);
      });
  });
};

export const vinculaSocial = (id, red, token, tokenRedSocial) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/vincular_red/", {
        id,
        red,
        token,
        tokenRedSocial,
      })
      .then((res) => {
        sessionStorage.token = token;
        let respuesta = {
          ...res.data,
          origen: "vinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "vinculaSocial",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const desvinculaSocial = (red, token) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/desvincular_red/", {
        red,
      })
      .then((res) => {
        sessionStorage.token = token;
        let respuesta = {
          ...res.data,
          origen: "desvinculaSocial",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "desvinculaSocial",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};
export const wsPostEditaImagenPerfil = (body) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/paciente/perfil", body)
      .then((res) => {
        let respuesta = {
          ...res.data,
          origen: "editaFoto",
        };
        dispatch({
          type: PACIENTE_SUCCESS,
          payload: respuesta,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "editaFoto",
        };

        dispatch({
          type: PACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetDatosBioseguridad = (nextStep) => (dispatch) => {
  dispatch({
    type: PACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/paciente/GetBioseguridadPacienteQr`)
      .then((res) => {
        dispatch({
          type: PACIENTE_BIOSEGURIDAD,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        dispatch({
          type: PACIENTE_BIOSEGURIDAD_ERROR,
          payload: err.response.data,
        });
        if (nextStep) nextStep(false, err.response);
      });
  });
};

export const logoutPaciente = (history) => (dispatch) => {
  sessionStorage.removeItem("token");
  dispatch({ type: PACIENTE_LOGOUT });
  history.push("/");
};

export const logoutPacientePerfil = () => (dispatch) => {
  dispatch({ type: PACIENTE_LOGOUT });
};

//FINALIZA AGREGADOS.

export const resetPaciente = () => (dispatch) => {
  dispatch({
    type: RESET_PACIENTE,
  });
};

export const logoutPacienteDefault = () => (dispatch) => {
  dispatch({ type: PACIENTE_LOGOUT });
};

// funcion de los dropdowns

export const setUserSelectEditar = (payload) => (dispatch) => {
  dispatch({
    type: DROPDOWN_SELECT_USER_EDITAR_P,
    payload,
  });
};
